import { useApiQuery } from "./useApiQuery";
import {
  getCities,
  getDealerInventory,
  getDealers,
  getOems,
  getVehicleInventoryBreakdowns,
  getVehicleInventorySummary,
} from "../api/vehicleInventory.api";

const keyOf = (obj) => JSON.stringify(obj);

export function useVehicleInventorySummary(filters = {}) {
  return useApiQuery((opts) => getVehicleInventorySummary({ ...filters, ...opts }), keyOf(filters));
}

export function useVehicleInventoryBreakdowns(filters = {}, { limit = 6 } = {}) {
  return useApiQuery(
    (opts) => getVehicleInventoryBreakdowns({ ...filters, limit, ...opts }),
    keyOf({ ...filters, limit }),
  );
}

export function useDealerInventory({ sort, page, pageSize, ...filters }) {
  return useApiQuery(
    (opts) => getDealerInventory({ sort, page, pageSize, ...filters, ...opts }),
    keyOf({ sort, page, pageSize, ...filters }),
  );
}

/**
 * Dropdown options (value = record id):
 *   OEM    → /api/vehicles/oem/
 *   Dealer → /api/vehicles/dealer/
 *   City   → /api/geographies/geography/cities/
 */
export function useInventoryFilterOptions() {
  return useApiQuery(async (opts) => {
    const [oems, dealers, cities] = await Promise.all([getOems(opts), getDealers(opts), getCities(opts)]);
    return { oems, dealers, cities };
  }, "filter-options");
}
